function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0139 45.0929C5.35818 34.7828 5.87914 19.3836 15.5766 9.68602C25.8246 -0.562005 42.4401 -0.562005 52.6881 9.68602C62.9362 19.934 62.9362 36.5495 52.6881 46.7975C44.8601 54.6256 33.3169 56.4742 23.7342 52.3432",
  stroke: "white",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.2086 19.9689C40.2086 19.9689 36.469 16.8255 32.0593 18.154C28.0101 19.3736 27.4438 24.0427 30.3732 25.9525C30.3732 25.9525 33.2477 27.2349 36.436 28.4109C44.1108 31.2418 40.8048 38.6666 34.6265 38.6666C31.5325 38.6666 28.9358 37.3118 27.3641 35.5774M34.1308 38.6546V42.8613M34.1308 13.6226V17.8293M21.5541 63.2049L25.6022 43.023L5.42039 47.071L10.2839 51.9347L1.625 60.5936L8.03154 67.0002L16.6905 58.3412L21.5541 63.2049Z",
  stroke: "white",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgGetPaidIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 69,
    viewBox: "0 0 62 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetPaidIcon);
export default __webpack_public_path__ + "static/media/get-paid_icon.51793ae0fd5500e1c3d1cf1954609720.svg";
export { ForwardRef as ReactComponent };